import { makeStyles } from '@material-ui/core';
export default makeStyles(function ()
/* theme */
{
  return {
    root: {}
  };
});